import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {DataTableDirective} from 'angular-datatables';
import {Subject} from 'rxjs';
import {TradeHistoryService} from '../../_services/trade-history.service';
import {Observable} from 'rxjs/Observable';
import {CoinConfigService} from '../../_services/coinconfig.service';
import {LineBotService} from '../../_services/line-bot.service';

@Component({
    selector: 'app-trade-history',
    templateUrl: './trade-history.component.html',
    styleUrls: ['./trade-history.component.css']
})
export class TradeHistoryComponent implements OnInit {

    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;
    searchWord: string;
    coinName: string;
    pairId: string;
    timeYear: string;
    timeMonth: string;
    timeDay: string;
    delayTimer: any;

    markets: Observable<any[]>;
    dataMarkets: any[] = [];
    objectMarkets: any = {};
    marketId: string;

    lineBotAlls: Observable<any[]>;
    lineBotId: number;
    // number index column profit in table data
    numberProfit: number = 5;
    // number index column updated_at in table data
    numberUpdatedAt: number = 8;
    orderSort: string = 'desc';
    numberOrderSort: number = this.numberUpdatedAt;
    /*
     * filterBy = 0; // load all trade history
     * filterBy = 1; // load trade history are unfinished
     * filterBy = 2; // load trade history are finished
     */
    filterBy = 0; // default load all in Bot

    constructor(
        private tradeHistoryService: TradeHistoryService,
        private coinConfigService: CoinConfigService,
        private lineBotService: LineBotService
    ) {
    }

    //get years from function initYears
    years = this.initYears();

    ngOnInit() {
        this.initDataTables();

        //markets
        this.markets = this.coinConfigService.getMarkets();
        this.markets.subscribe(data => {
            this.dataMarkets = data;
            data.forEach(element => {
                this.objectMarkets[element.id] = element.name;
            });
        });

        //list all bot
        this.lineBotAlls = this.lineBotService.getLineBot();
    }

    initDataTables() {
        let self = this;
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[self.numberUpdatedAt, self.orderSort], [self.numberProfit, 'desc']],//col 8 in table - updated_at ---And--- col 5 in table - profit
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.coinName || '';
                parameters["search"]["pair"] = self.pairId || '';

                //get param search timeYear, timeMonth & timeDay
                parameters["search"]["timeYear"] = self.timeYear || '';
                parameters["search"]["timeMonth"] = self.timeMonth || '';
                parameters["search"]["timeDay"] = self.timeDay || '';
                parameters["search"]["filterTrade"] = self.filterBy;

                let rankingSortProfit = $('#table-trade-history th').eq(self.numberProfit);
                let isClickProfit = false;
                let numberSort = self.numberUpdatedAt;
                let nameSortOrderBy = self.orderSort;

                parameters['order'].forEach(function (element, index) {
                    isClickProfit = parameters['columns'][element.column].orderable == true && element.column == self.numberProfit;
                    if (isClickProfit) {
                        numberSort = self.numberOrderSort;
                        nameSortOrderBy = self.orderSort;
                        return false;
                    }
                });

                // click sort column profit
                if (isClickProfit) {
                    parameters['search']['clickOrderBy'] = nameSortOrderBy;
                    parameters['search']['clickOrder'] = parameters['columns'][numberSort].name;
                }
                parameters['search']['profit'] = isClickProfit
                    ? parameters['order'].length > 1
                        ? rankingSortProfit.hasClass('sorting_asc') ? 'asc' : 'desc'
                        : rankingSortProfit.hasClass('sorting_desc') ? 'asc' : 'desc'
                    : rankingSortProfit.hasClass('sorting_asc') ? 'asc' : 'desc';

                self.lineBotAlls.subscribe(dataLineBot => {
                    if (dataLineBot && dataLineBot.constructor === Array && dataLineBot.length) {
                        self.coinConfigService.getMarkets().subscribe(dataMarket => {
                            parameters["search"]["market"] = self.marketId || dataMarket[0].id;
                            parameters["search"]["line_bot_id"] = self.lineBotId || dataLineBot[0].id;
                            self.tradeHistoryService.gets(parameters).subscribe(result => {
                                callback({
                                    draw: parameters['draw'],
                                    data: result.data,
                                    recordsTotal: result.data.length,
                                    recordsFiltered: result.recordsTotal
                                });
                                $('.total_profit').html(result.total_profit.toFixed(8) + ' %');
                                rankingSortProfit.removeClass('sorting sorting_asc sorting_desc').addClass('sorting_' + parameters['search']['profit']);
                                if (result.hasOwnProperty('clickSort') && result.clickSort) {
                                    $('#table-trade-history th').eq(self.numberOrderSort).removeClass('sorting sorting_asc sorting_desc').addClass('sorting_' + result.clickSort.split(':')[1]);
                                }
                                // Update index and column order field sort
                                self.getColumnSort();
                            });
                        });
                    }
                });
            },
            columns: [{
                title: "コイン名",
                data: "coin_name",
                name: "coin_name",
                className: "all text-justify"
            },
            {
                title: "コイン市場名",
                data: "pair",
                name: "pair",
                className: "all text-justify"
            },
            {
                title: "買い価値",
                data: function (item) {
                    return item.buy_price != null && item.buy_price ? item.buy_price.toFixed(8) : '--';
                },
                name: "buy_price",
                className: "text-justify"
            }, {
                title: "売り価値",
                data: function (item) {
                    return item.sell_price != null && item.sell_price ? item.sell_price.toFixed(8) : '--';
                },
                name: "sell_price",
                className: "all text-justify"
            },
            {
                title: "収益",
                data: function (item) {
                    return item.revenue != null && item.revenue ? item.revenue.toFixed(8) : '--';
                },
                orderable: false,
                className: "all text-right"
            }, {
                title: "利益",
                data: function (item) {
                    return (item.profit != null && item.sell_price && item.buy_price) ? item.profit.toFixed(8) + ' %' : '--';
                },
                orderable: true,
                className: "all text-right"
            },
            {
                title: "買い時間",
                data: function (item) {
                    return item.buy_price ? item.bought_at : '--';
                },
                name: "bought_at",
                className: "text-right"
            },
            {
                title: "売り時間",
                data: function (item) {
                    return item.sell_price ? item.sold_at : '--';
                },
                name: "sold_at",
                className: "all text-right"
            },
            {
                title: "更新時間",
                data: "updated_at",
                name: "updated_at",
                className: "all text-right"
            }]
        };
    }

    //event change time year
    onChangeTimeYear(event) {
        //declare timeDay is ''
        this.timeDay = '';

        //if timeYear is empty 
        // => disabled + set val null to option timeMonth
        // => disabled + set val null to option timeDay
        //and else
        if (event.target.value == '') {
            $('#timeMonth').val('');
            $('#timeMonth').attr('disabled', 'disabled');
            $('#timeDay').val(' ');
            $('#timeDay').attr('disabled', 'disabled');
        } else {
            $('#timeMonth').removeAttr('disabled');

            //pass param to function set list days
            var yearSearch = event.target.value;
            var monthSearch = parseInt(this.timeMonth);
            this.setListDays(yearSearch, monthSearch);
        }
        //transfer value timeYear
        this.timeYear = event.target.value;
        this.rerenderDataTable();
    }

    //event change time month
    onChangeTimeMonth(event) {
        //declare timeDay is ''
        this.timeDay = '';

        //if timeMonth is empty 
        // => disabled + set val null to option timeDay
        //and else
        if (event.target.value == '') {
            $('#timeDay').val(' ');
            $('#timeDay').attr('disabled', 'disabled');
        } else {
            $('#timeDay').removeAttr('disabled');

            //pass param to function set list days
            var yearSearch = parseInt(this.timeYear);
            var monthSearch = event.target.value;
            this.setListDays(yearSearch, monthSearch);

        }
        //transfer value timeMonth
        this.timeMonth = event.target.value;
        this.rerenderDataTable();
    }

    //event change time day
    onChangeTimeDay(event) {
        //transfer value timeDay
        this.timeDay = event.target.value;
        this.rerenderDataTable();
    }

    onChange(event) {
        this.pairId = event.target.value;
        this.rerenderDataTable();
    }

    valuechange(newValue) {
        this.coinName = newValue;
        this.doSearch();
    }

    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.rerenderDataTable();
        }, 600); // Will do the ajax stuff aft
    };

    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    //init list 10 years nearest
    initYears() {
        //get year current
        var yearCurrent = new Date().getFullYear();
        var years = [];

        //push year current into array
        years.push(
            {id: yearCurrent}
        );

        //push 10 year into array
        for (var i = 1; i < 10; i++) {
            years.push(
                {id: yearCurrent - i}
            );
        }
        return years;
    }

    //set list days from yearSearch & monthSearch
    setListDays(yearSearch, monthSearch) {
        //get last day in month
        var lastDayInMonth = new Date(yearSearch, monthSearch, 0).getDate();

        //reset option day 
        $('#timeDay option').remove();

        //append option defaut all
        $('#timeDay').append($('<option>', {
            value: ' ',
            text: 'すべて'
        }));

        //loop to append list day
        for (var i = lastDayInMonth; i >= 1; i--) {
            //concate 0 to day < 10
            var valueDay = i < 10 ? '0' + i : i;
            $('#timeDay').append($('<option>', {
                value: valueDay,
                text: i
            }));
        }
    }

    onChangeMarkets(event) {
        this.marketId = event.target.value;
        this.rerenderDataTable();
    }

    //change value line_bot_id
    onChangeLineBot(event) {
        this.lineBotId = event.target.value;
        this.rerenderDataTable();
    }

    // Set numberOrderSort and orderSort after click sort
    private getColumnSort() {
        let self = this;
        $.each($('#table-trade-history th'), function (index, element) {
            if (self.numberProfit == +index) {
                return true;
            }
            if ($(element).hasClass('sorting_asc')) {
                self.orderSort = 'asc';
                self.numberOrderSort = +index;
            } else if ($(element).hasClass('sorting_desc')) {
                self.orderSort = 'desc';
                self.numberOrderSort = +index;
            }
        })
    }

    // choose filter trade history 
    onChangeFilter(event) {
        this.filterBy = event.target.value;
        this.rerenderDataTable();
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/trade-history/trade-history.component.ts